import React from 'react'

export const Reply = (props) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill={props.fill || 'none'}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_34_7673)'>
      <path
        d='M11 14V19L1 11L11 3V8C16.523 8 21 12.477 21 18C21 18.273 20.99 18.543 20.968 18.81C20.2044 17.3582 19.0585 16.1427 17.6541 15.2949C16.2498 14.4471 14.6404 13.9994 13 14H11Z'
        fill={props.fill || 'currentColor'}
      />
    </g>
    <defs>
      <clipPath id='clip0_34_7673'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
